<!-- 注册页面 -->
<template>
    <div>
        <div class="login-cont">
            <div class="cont-2">
                <!--忘记密码-->
                <div class="col-2 find-pwd">
                    <p class="title">忘记密码</p>
                    <!--表单-->
                    <div class="form-box">
                        <el-form :model="loginForm" :rules="rules" ref="loginForm" label-width="0px" class="login-form" @submit.native.prevent>
                            <el-form-item prop="tel">
                                <!-- <i class="label-txt el-icon-mobile-phone"></i> -->
                                <el-input v-model.trim="loginForm.tel" placeholder="请输入手机号" maxlength="11" ref="tel"
                                    clearable autocomplete="on">
                                </el-input>
                            </el-form-item>
                            <el-form-item prop="code">
                                <!-- <i class="label-txt el-icon-lock"></i> -->
                                <el-input type="txt" class="padding-right" placeholder="请输入验证码" maxlength="6"
                                    autocomplete="off" v-model.trim="loginForm.code" clearable>
                                </el-input>
                                <el-button v-show="codeSta" 
                                    :class="{'get-code-btn': true, 'disabled': !loginForm.tel || !/^1[3456789]\d{9}$/.test(loginForm.tel)}"
                                    @click="getCode()">获取验证码</el-button>
                                <el-button v-show="!codeSta" class="get-code-btn">{{ count }}s</el-button>
                            </el-form-item>
                            <el-form-item prop="pwd">
                                <!-- <i class="label-txt el-icon-lock"></i> -->
                                <el-input type="password" placeholder="新密码(8-20位大小字母、数字、符号组合)" v-model="loginForm.pwd"
                                    clearable show-password>
                                </el-input>
                            </el-form-item>

                            <div class="login-btn">
                                <el-button type="primary" @click="submitForm('loginForm')" native-type="submit"
                                    :disabled="!loginForm.tel || !loginForm.code || !loginForm.pwd">确定重置
                                </el-button>
                            </div>
                        </el-form>
                    </div>
                    <div class="err-txt" :class="{'has-cont': errTxt}">
                        <p>{{errTxt}}</p>
                    </div>
                    <p class="to-register" @click="toLogin">返回登录</p>
                </div>
            </div>
        </div>

        <!-- 手机号未注册 -->
        <el-dialog class="public-dialog" title="" :visible.sync="dialogVisible" width="30%" top=350px>
            <span>您的手机号暂未注册</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="toRegister">立即注册</el-button>
            </span>
        </el-dialog>
    </div>
</template>


<script>
    import loginApi from '@/resources/loginModule/login'
    import config from '@/config'

    export default {
        data: function () {
            // 验证密码
            let checkPwd = (rule, value, callback) => {
                let reg = /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)]|[\\(\\)])+$)([^(0-9a-zA-Z)]|[\\(\\)]|[a-z]|[A-Z]|[0-9]){8,20}$/;
                if (!value) {
                    return callback(new Error('请输入密码'));
                } else if (!reg.test(value)) {
                    return callback(new Error('8-20位大小字母、数字、符号组合'));
                } else {
                    callback();
                }
            };
            // 验证手机号
            let checkTel = (rule, value, callback) => {
                let reg = /^1[3456789]\d{9}$/;
                if (!value) {
                    return callback(new Error("请输入手机号"));
                } else if (!reg.test(value)) {
                    return callback(new Error("请输入正确的手机号"));
                } else {
                    callback();
                }
            };
            return {
                errTxt: '', //错误提示
                pasSta: true, //密码是否显示
                btnSta: false, //按钮是否可点击
                codeSta: true, //获取验证码按钮状态
                count: '',
                timer: null,
                //表单数据
                loginForm: {
                    userName: "",
                    pwd: "",
                    tel: "",
                    code: ""
                },
                //校验
                rules: {
                    pwd: [{ required: true, validator: checkPwd, trigger: "blur" }],
                    tel: [{ required: true, validator: checkTel, trigger: "blur" }],
                    code: [{ required: true, message: "请输入验证码", trigger: "blur" }]
                },
                ischecked: false,
                dialogVisible: false,
                appId: null,
                showRegiste: true,
            };
        },
        computed: {},
        created() {
            if (sessionStorage.showMode && !/registe/i.test(sessionStorage.showMode)) {
                this.showRegiste = false;
            }
        },
        mounted() {
            this.appId = sessionStorage.appId;
        },
        methods: {
            changePwaSta() {
                this.pasSta = !this.pasSta;
            },
            // 获取验证码
            getCode() {
                if (!/^1[3456789]\d{9}$/.test(this.loginForm.tel)) {
                    return false;
                }
                this.sendMobileCode();
            },
            // 验证码倒计时
            codeCountdown() {
                const TIME_COUNT = 60;
                if (!this.timer) {
                    this.count = TIME_COUNT;
                    this.codeSta = false;
                    this.timer = setInterval(() => {
                        if (this.count > 0 && this.count <= TIME_COUNT) {
                            this.count--;
                        } else {
                            this.codeSta = true;
                            clearInterval(this.timer);
                            this.timer = null;
                        }
                    }, 1000);
                }
            },
            // 找回密码
            submitForm(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        let para = {
                            mobile: this.loginForm.tel,
                            password: this.loginForm.pwd,
                            captcha: this.loginForm.code,
                        };
                        loginApi.forgetPassword(para).then((res) => {
                            if (res.returnCode === 200) {
                                this.$message.success("修改成功，请重新登录");
                                this.toLogin();
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
            //发送验证码
            sendMobileCode() {
                let that = this;
                let para = {
                    mobile: that.loginForm.tel,
                    operationFlag: 2   //1.注册 2.忘记密码 3.登录 4.绑定手机号
                };
                loginApi.sendMobileCode(para).then((res) => {
                    if (res.returnCode === 200) {
                        that.codeCountdown();
                    } else if (res.returnCode === 40015) {
                        that.dialogVisible = true
                    }
                });
            },
            login() {
                this.errTxt = "请输入正确的手机号";
                this.loginForm.tel.errsta = 2;
            },
            toRegister() {
                this.$router.push({ path: "/web/registe" });
            },
            toLogin() {
                let path = '/web/login';
                if (this.$route.query.gptLogin) {
                    path = '/web/gptLogin'
                }
                console.log(path);
                this.$router.push(path);
            }
        },
    };
</script>

<style scoped>
    @import '../../../assets/css/login/login.css';
</style>